module.exports = __webpack_public_path__ + "static/media/FGO2016Summer.9940712b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/tc/FGO2016Summer.png
// module id = 1145
// module chunks = 0